"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toValidRGB = toValidRGB;

/**
 * Converts the value to a valid RGB color.
 * @param value Converted value.
 */
function toValidRGB(value) {
  var rgb = value.map(function (v) {
    if (Number(v) < 0) return 0;else if (Number(v) > 255) return 255;else return Number(v);
  });
  return {
    r: rgb[0],
    g: rgb[1],
    b: rgb[2]
  };
}